'use client';
import { motion } from 'framer-motion';
import { MapPin, Calendar, Coffee } from 'lucide-react';

export default function About() {
  const stats = [
    { label: 'Projects Built', value: '10+' },
    { label: 'Technologies', value: '15+' },
    { label: 'Years Learning', value: '3+' },
    { label: 'Cups of Tea ☕', value: '∞' },
  ];

  return (
    <section id="about" className="section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="accent-line" />
          <h2 className="section-title">About Me</h2>
          <p className="section-subtitle">A little about who I am and what drives me</p>
        </motion.div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem', alignItems: 'center' }} className="about-grid">
          {/* Text */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p style={{ color: 'var(--text-muted)', lineHeight: 1.9, marginBottom: '1.5rem', fontSize: '1.05rem' }}>
              Hi! I&apos;m <strong style={{ color: 'var(--text-primary)' }}>Muhammad Umer Shah Farooqi</strong>, a passionate Full Stack Developer
              based in Pakistan. I specialize in building end-to-end web applications with a
              focus on <span style={{ color: 'var(--accent)' }}>Django</span> backends and modern frontends.
            </p>
            <p style={{ color: 'var(--text-muted)', lineHeight: 1.9, marginBottom: '1.5rem', fontSize: '1.05rem' }}>
              I believe in writing clean, maintainable code and building products that actually
              solve problems. When I&apos;m not coding, you&apos;ll find me exploring new technologies,
              writing blog posts, or mentoring other developers.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '2rem' }}>
              {[
                { icon: <MapPin size={16} />, text: 'Pakistan' },
                { icon: <Calendar size={16} />, text: 'Available for opportunities' },
                { icon: <Coffee size={16} />, text: 'Django & Python enthusiast' },
              ].map(({ icon, text }) => (
                <div key={text} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', color: 'var(--text-muted)' }}>
                  <span style={{ color: 'var(--accent)' }}>{icon}</span>
                  <span>{text}</span>
                </div>
              ))}
            </div>
            <a href="#contact" className="btn btn-primary" id="about-hire-me">Hire Me</a>
          </motion.div>

          {/* Stats grid */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}
          >
            {stats.map(({ label, value }, i) => (
              <motion.div
                key={label}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.1 * i }}
                className="card"
                style={{ textAlign: 'center', padding: '2rem 1rem' }}
              >
                <div style={{ fontSize: '2.5rem', fontWeight: 800, fontFamily: 'Outfit, sans-serif', marginBottom: '0.5rem' }} className="gradient-text">
                  {value}
                </div>
                <div style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>{label}</div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
      <style>{`
        @media (max-width: 768px) { .about-grid { grid-template-columns: 1fr !important; gap: 2rem !important; } }
      `}</style>
    </section>
  );
}
